import type { ReactNode } from 'react';

interface Props {
  status: 'ok' | 'warn' | 'err' | 'idle';
  size?: 'sm' | 'md';
  label?: ReactNode;
}

const COLORS: Record<Props['status'], string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  err: 'bg-err',
  idle: 'bg-text-mute',
};

export function StatusDot({ status, size = 'sm', label }: Props): JSX.Element {
  const px = size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5';
  return (
    <span className="inline-flex items-center gap-2 text-xs text-text-dim">
      <span className={`rounded-full ${px} ${COLORS[status]}`} />
      {label}
    </span>
  );
}
